import React from 'react';
import PlainCRUD from 'components/PlainCRUD';
import { getCatalogoDePadrones } from 'api/catalogos';

const Padrones = () => (
  <PlainCRUD title="Padrones" get={getCatalogoDePadrones} readOnly />
);

export default Padrones;
